import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlanCard = ({ plan, isSelected, onSelect, currentLanguage, billingCycle }) => {
  const content = {
    fr: {
      perMonth: '/mois',
      perYear: '/an',
      selectPlan: 'Choisir ce plan',
      selected: 'Plan sélectionné',
      popular: 'Populaire',
      savePercent: 'Économisez 20%'
    },
    ar: {
      perMonth: '/شهر',
      perYear: '/سنة',
      selectPlan: 'اختر هذه الخطة',
      selected: 'الخطة المحددة',
      popular: 'الأكثر شعبية',
      savePercent: 'وفر 20%'
    }
  };

  const text = content?.[currentLanguage];

  const price = billingCycle === 'monthly' ? plan?.monthlyPrice : plan?.annualPrice;
  const period = billingCycle === 'monthly' ? text?.perMonth : text?.perYear;

  return (
    <div
      className={`
        relative rounded-xl border-2 p-4 md:p-6 lg:p-8 transition-all duration-300
        ${isSelected 
          ? 'border-primary bg-primary/5 shadow-warm-lg' 
          : 'border-border bg-card hover:border-primary/50 hover:shadow-warm'
        }
        ${plan?.isPopular ? 'ring-2 ring-primary/20' : ''}
      `}
    >
      {plan?.isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full shadow-warm">
            {text?.popular}
          </span>
        </div>
      )}
      {billingCycle === 'annual' && (
        <div className="absolute -top-3 right-4">
          <span className="px-3 py-1 bg-success text-success-foreground text-xs font-semibold rounded-full shadow-warm">
            {text?.savePercent}
          </span>
        </div>
      )}
      <div className="text-center mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
          {plan?.name?.[currentLanguage]}
        </h3>
        <p className="caption text-muted-foreground mb-4">
          {plan?.description?.[currentLanguage]}
        </p>
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground data-text">
            {price}
          </span>
          <span className="text-lg text-muted-foreground">MAD</span>
          <span className="text-sm text-muted-foreground">{period}</span>
        </div>
      </div>
      <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8">
        {plan?.features?.[currentLanguage]?.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Icon 
              name="Check" 
              size={20} 
              className="text-primary flex-shrink-0 mt-0.5" 
            />
            <span className="text-sm text-foreground">{feature}</span>
          </li>
        ))}
      </ul>
      <Button
        variant={isSelected ? 'default' : 'outline'}
        fullWidth
        onClick={() => onSelect(plan?.id)}
        iconName={isSelected ? 'Check' : 'ArrowRight'}
        iconPosition="right"
      >
        {isSelected ? text?.selected : text?.selectPlan}
      </Button>
    </div>
  );
};

export default PlanCard;